<template>
  <div
    class="w-100 h-100"
  >
    <BgLeaves
      v-if="brand === 'lh'"
      :trigger="leaves"
      :position="[0, 0, 0, 1]"
      :inset="20"
    />
    <div
      class="flex items-center justify-center h-100 pr5 w-100 top-0"
      style="padding-left: 25vw;"
    >
      <div
        class="flex items-center"
        style="max-height: 52vh;"
      >
        <div class="w-50 flex flex-wrap">
          <div
            v-if="content.about.gallery[0] !== undefined"
            class="w-100 ba b--white"
          >
            <div class="aspect-ratio aspect-ratio--16x9">
              <div
                class="aspect-ratio--object cover"
                :style="'background:url(' + content.about.gallery[0] + ') center;'"
              />
            </div>
          </div>
          <div
            v-if="content.about.gallery[1] !== undefined"
            class="w-50 ba b--white"
          >
            <div class="aspect-ratio aspect-ratio--6x4">
              <div
                class="aspect-ratio--object cover"
                :style="'background:url(' + content.about.gallery[1] + ') center;'"
              />
            </div>
          </div>
          <div
            v-if="content.about.gallery[2] !== undefined"
            class="w-50 ba b--white"
          >
            <div class="aspect-ratio aspect-ratio--6x4">
              <div
                class="aspect-ratio--object cover"
                :style="'background:url(' + content.about.gallery[2] + ') center;'"
              />
            </div>
          </div>
        </div>
        <div
          class="bottom-blur relative flex flex-column w-50 mh5 lh-copy"
          style="max-height: inherit"
        >
          <div
            class="f1 b mb3"
            :class="{
              'purple': brand === 'lh',
              'dark-gray': brand === 'lq'
            }"
          >
            About
          </div>
          <div
            class="top-blur relative bt bw1 w3 mb4"
            :class="{
              'b--purple': brand === 'lh',
              'b--dark-gray': brand === 'lq'
            }"
          />
          <div
            class="relative slider-content about flex flex-column overflow-auto w-100 pb4 pr3 pt3"
          >
            <div v-html="content.about.text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BgLeaves from '@/components/BgLeaves.vue'

export default {
  name: 'LaurusHomes',
  components: {
    BgLeaves
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  },
  data () {
    return {
      leaves: false
    }
  },
  computed: {
    content () {
      if (this.$store.state.content !== null) {
        return this.$store.state.content
      } else {
        return null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  }
}
</script>

<style lang="scss">
.about {
  p:first-child {
    // font-size: 1.25rem !important;
    font-weight: bold;
  }
}
</style>
